<template>
  <div class="journal-entries">
    <search-modal
      :showSearchModal="showSearchModal"
      @toggle-modal="$emit('toggle-modal')"
      :entity="entity"
      :filterCriteria="filterCriteria"
      :columnHeaders="columnHeaders"
      :type="type"
      :title="title"
      :filter="filter"
      :sort="sort"
      :hideFilter="hideFilter"
      :rowsPerPageLimit="rowsPerPageLimit"
      @search-items="handleSearchItems"
    >
      <!-- <template #footer>
        <div class="journal-entries__header">
          <div>Credits: ${{ credits }}</div>
          <div>Debits: ${{ debits }}</div>
          <div>Balance: ${{ balance }}</div>
        </div>
      </template> -->
    </search-modal>
  </div>
</template>

<script>
import Entities from "@/resources/Entities";
import { filterCriteria, columnHeaders } from "./inputs";

export default {
  name: "JournalEntries",
  props: {
    showSearchModal: Boolean,
    type: {
      type: String,
      default: "all",
    },
    filter: {
      type: Object,
    },
    sort: {
      type: Object,
    },
    hideFilter: {
      type: Boolean,
      default: false,
    },
    rowsPerPageLimit: {
      type: Number,
      default: undefined,
    },
  },
  data() {
    return {
      filterCriteria,
      columnHeaders,
      entity: Entities.JOURNAL,
      credits: 0,
      debits: 0,
      balance: 0,
    };
  },
  mounted: function () {},
  computed: {
    title() {
      switch (this.type) {
        case "purchaseOrder":
          return "Journal Entries: Purchase Order - All";
        case "supplier":
          return "Journal Entries: Supplier - All";
        case "order":
          return "Journal Entries: Order - All";
        case "orderPayments":
          return "Journal Entries: Order - Payments";
        case "customer":
          return "Journal Entries: Customer - All";
        case "customerPayments":
          return "Journal Entries: Customer - Payments";
        default:
          return undefined;
      }
    },
  },
  methods: {
    handleSearchItems(items) {
      this.credits = (items.reduce((acc, item) => acc + parseFloat(item.credits), 0)).toFixed(2);
      this.debits = (items.reduce((acc, item) => acc + parseFloat(item.debits), 0)).toFixed(2);
      this.balance = (this.credits - this.debits).toFixed(2);
    },
  },
};
</script>

<style scoped lang="scss">
@import "./_journal-entries.scss";

.journal-entries__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
}
</style>
